import StatamicObject from "./statamicObject"
import Poi from "./poi"
import i18n from "i18next"

export default class Profile extends StatamicObject {
  constructor(data) {
    super(data)
    Object.assign(this, data)
  }

  getPois() {
    return this.poi ? this.poi.map(poi => new Poi(poi)) : []
  }

  getFullName() {
    if (this.displayFirstnameOnly) {
      return this.firstName
    }

    if (!this.titre.value) {
      return this.title
    }

    return this.titre.value.toUpperCase() + ". " + this.title
  }
}
